import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetSessionFeeStatusParams {
  sessionId: string;
  parentId: string;
  studentId?: string;
}

interface UseGetSessionFeeStatusOptions {
  enabled?: boolean;
}

interface GetSessionFeeStatusResponse {
  isPerStudentFeePaid: boolean;
  perStudentFee: number;
  isPerFamilyFeePaid: boolean;
  perFamilyFee: number;
}

export const getSessionFeeStatus = async ({
  sessionId,
  parentId,
  studentId,
}: GetSessionFeeStatusParams) => {
  const response = await baseAPI.get<GetSessionFeeStatusResponse>(
    `/session/${sessionId}/session-fee-status`,
    {
      params: {
        parentId,
        studentId,
      },
    },
  );
  return response.data;
};

export const useGetSessionFeeStatus = (
  params: GetSessionFeeStatusParams,
  options?: UseGetSessionFeeStatusOptions,
) => {
  return useQuery({
    queryKey: [
      KEYS.SESSION_FEE_STATUS,
      params.sessionId,
      params.parentId,
      params.studentId,
    ],
    queryFn: () => getSessionFeeStatus(params),
    enabled: options?.enabled,
  });
};
